import { posthog } from 'posthog-js';

export interface SessionReplayContext {
  /** Link to this PostHog session's replay, from the start of the session. */
  sessionReplayUrl: string;
  /** PostHog session id — searchable in PostHog even without the link. */
  posthogSessionId: string;
  /** Whether PostHog is actually recording this session. `false` means the
   * link opens the session, but there is no video to watch (recording off,
   * sampled out, or blocked). */
  sessionReplayRecording: boolean;
}

/**
 * PostHog session replay context for an error log, so support can watch what
 * the user did just before the error. Returns undefined when PostHog isn't
 * loaded (not configured, no analytics consent yet, blocked by an ad-blocker)
 * — the error log is then sent without it. Never throws.
 */
export function getSessionReplayContext(): SessionReplayContext | undefined {
  try {
    if (!posthog.__loaded) {
      return undefined;
    }
    const posthogSessionId = posthog.get_session_id();
    if (!posthogSessionId) {
      return undefined;
    }
    return {
      // No timestamp: the replay opens at 0:00, so the whole session leading up
      // to the error can be watched (the error's `timestamp` marks where it happened).
      sessionReplayUrl: posthog.get_session_replay_url(),
      posthogSessionId,
      sessionReplayRecording: posthog.sessionRecordingStarted(),
    };
  } catch {
    return undefined;
  }
}
